export const getCachedImage = (imageId) => {
  return localStorage.getItem(`party_symbol_${imageId}`);
};

export const setCachedImage = (imageId, imageData) => {
  try {
    localStorage.setItem(`party_symbol_${imageId}`, imageData);
  } catch (e) {
    console.warn("Image cache full, skipping cache");
  }
};
